import { render, staticRenderFns } from "./SrVideoUploadEditor.vue?vue&type=template&id=d81610f6&"
import script from "./SrVideoUploadEditor.vue?vue&type=script&lang=js&"
export * from "./SrVideoUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./SrVideoUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports